import React from 'react';
import styled from 'styled-components';

export const CONNECTED_PLUS_INFO_COPY =
  'skubot only searches connected+ products, so every result comes with verified data and full configuration options.';

const Root = styled.div`
  &&& {
    display: block;
    width: 100%;
    align-self: stretch;
    min-height: 36px;
    box-sizing: border-box;
    background: var(--chakra-colors-info-subtle, #f0f5fa);
    border: 1px solid var(--chakra-colors-info-muted, #e2ecf5);
    border-radius: 6px;
    padding: 8px;
  }
`;

const Copy = styled.p`
  &&& {
    margin: 0;
    padding: 0;
    border: 0;
    font-family: var(--chakra-fonts-body, Inter, system-ui, sans-serif);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0;
    color: var(--chakra-colors-info-fg, #0961a9);
  }
`;

export function ConnectedPlusInfoBox() {
  return (
    <Root>
      <Copy>{CONNECTED_PLUS_INFO_COPY}</Copy>
    </Root>
  );
}
